import oneLine from 'common-tags/es/oneLine/oneLine';

import homepage from './homepage';
import income from './measures/income';
import essentials from './measures/essentials';
import food from './measures/food';
import home from './measures/home';
import health from './measures/health';
import about from './about';
import contact from './contact';

const data = {
    pages: [
        homepage,
        income,
        essentials,
        food,
        home,
        health,
        about,
        contact,
    ],
    menu: [
        {
            name: 'Poverty measures',
            link: '/measures',
            submenu: [
                { name: 'Income', link: '/income' },
                { name: 'Essentials', link: '/essentials' },
                { name: 'Health', link: '/health' },
                { name: 'Home', link: '/home' },
                { name: 'Food', link: '/food' },
            ],
        },
        {
            name: 'About the project',
            link: '/about',
        },
        {
            name: 'Contact us',
            link: '/contact',
        },
    ],
    general: {
        contact: {
            email: 'childpoverty@occ.org.nz',
            twitter: 'https://twitter.com/povertymonitor',
            facebook: 'https://www.facebook.com/childpovertymonitor',
        },
        sponsors: [
            {
                name: 'Office of the Children\'s Commissioner',
                url: 'https://www.occ.org.nz/',
                image: {
                    filename: 'childrens-commissioner-logo.png',
                },
            },
            {
                name: 'JR McKenzie Trust',
                url: 'https://www.jrmckenzie.org.nz/',
                image: {
                    filename: 'jr-mckenzie-trust-logo.png',
                    classes: 'w-20',
                },
            },
            {
                name: 'Otago University',
                url: 'https://www.otago.ac.nz/',
                image: {
                    filename: 'otago-university-logo.png',
                    classes: 'w-64',
                },
            },
        ],
        message: oneLine`The source of all data on this site is available in the 
            <a class="font-semibold underline-link-basic" href="http://hdl.handle.net/10523/9827">Child Poverty Monitor: Technical Report</a>, 
            produced by the New Zealand Child and Youth Epidemiology Service at the University of Otago. To find out 
            more about child poverty, you can read the Children’s Commissioner’s Expert Advisory Group report 
            <a class="font-semibold underline-link-basic" href="http://hdl.handle.net/10523/9827">Solutions to Child Poverty in New Zealand: Evidence for Action</a>.`,
        technicalReport: 'http://hdl.handle.net/10523/9827',
    },
};

export default data;
